import blueGrey from "@material-ui/core/colors/blueGrey";
import blue from "@material-ui/core/colors/blue";
import cyan from "@material-ui/core/colors/cyan";
import indigo from "@material-ui/core/colors/indigo";
import amber from "@material-ui/core/colors/amber";
import lightGreen from "@material-ui/core/colors/lightGreen";
import teal from "@material-ui/core/colors/teal";
import green from "@material-ui/core/colors/green";

export const colors = {
  main: "#5D6965",
  grey: "#A3A3A3",
  lightGrey: "#F0F0F0",
  blueGrey: {
    200: blueGrey["200"],
    500: blueGrey["500"],
  },
  blue: {
    200: blue["200"],
    500: blue["500"],
  },
  cyan: {
    400: cyan["400"],
  },
  indigo: {
    200: indigo["400"],
  },
  amber: {
    500: amber["500"],
  },
  green: {
    600: green["600"],
  },
  lightGreen: {
    200: lightGreen["200"],
  },
  teal: {
    500: teal["500"],
  },
};

export const styles = {
  chip: {
    textTransform: "uppercase",
    fontFamily: "Outfit, sans-serif",
    fontSize: "12px",
    fontWeight: 500,
    borderRadius: "8px",
    margin: "4px",
    color: colors.grey,
    backgroundColor: colors.lightGrey,
  },
  title: {
    color: colors.main,
    fontFamily: "Outfit, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    textDecoration: "none",
  },
  input: {
    fontFamily: "Outfit, sans-serif",
    fontSize: "18px",
    fontWeight: 300,
    color: colors.grey,
  },
  subtitle: {
    color: colors.grey,
    fontFamily: "Outfit, sans-serif",
    fontSize: "14px",
    fontWeight: 300,
  },
};



// WEBPACK FOOTER //
// ./src/styles/index.js